<template>
<b-row>
   
    <RegionOverview :lgSize="12"></RegionOverview>

    <ActiveBacklog v-if="!details" :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" @detailView="switchView"  ></ActiveBacklog>
    <ActiveBacklog2 v-else :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" :details="1" @detailView="switchView" @modalLocation="modalLocation"></ActiveBacklog2>

    <ShippedByFNS ref="shipLine" v-if="!detailsShip" :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" @detailViewShip="switchViewShip" @modalLocationShip="modalLocationShip"></ShippedByFNS>
    <ShippedByFNS2 v-else :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" :details="1" @detailViewShip="switchViewShip"></ShippedByFNS2>

    <RepairAnalytics v-if="!detailsRepair" :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" @detailViewRepair="switchViewRepair" ></RepairAnalytics>
    <RepairAnalytics2 v-else :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" :details="1" @detailViewRepair="switchViewRepair"></RepairAnalytics2>


    <HistoricalData v-if="!detailsHistorical" :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" @detailViewHistorical="switchViewHistorical"></HistoricalData>
    <HistoricalData2 v-else :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0" :details="1" @detailViewHistorical="switchViewHistorical"></HistoricalData2>

</b-row>
</template>

<script>
import ActiveBacklog from "../../components/ActiveBacklog-Column";
import ActiveBacklog2 from "../../components/ActiveBacklog-Stacked";

import ShippedByFNS from "../../components/ShippedByFNS-Column";
import ShippedByFNS2 from "../../components/ShippedByFNS-Stacked";

import RepairAnalytics from "../../components/RepairAnalytics-Line";
import RepairAnalytics2 from "../../components/RepairAnalytics-Stacked";

import HistoricalData from "../../components/HistoricalData-Line";
import HistoricalData2 from "../../components/HistoricalData-Stacked";

import RegionOverview from "../../components/RegionOverview";
import Highcharts from "highcharts";

export default {
  name: "dashboard",
  components: {
    ActiveBacklog,
    ActiveBacklog2,
    ShippedByFNS,
    ShippedByFNS2,
    RepairAnalytics,
    RepairAnalytics2,
    HistoricalData,
    HistoricalData2,
    RegionOverview
  },
  data: function() {
    return {
      details: false,
      detailsShip: false,
      detailsRepair: false,
      detailsHistorical: false,
    }
  },
  methods: {
    switchView() {
      if(this.details == false) {
        this.details = true;
      } else {
        this.details = false;
      }
    },
    switchViewShip() {
      if(this.detailsShip == false) {
        this.detailsShip = true;
      } else {
        this.detailsShip = false;
      }
    },
    switchViewRepair() {
      if(this.detailsRepair == false) {
        this.detailsRepair = true;
      } else {
        this.detailsRepair = false;
      }
    },
    switchViewHistorical() {
      if(this.detailsHistorical == false) {
        this.detailsHistorical = true;
      } else {
        this.detailsHistorical = false;
      }
    }
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
